import PolicyWrapper from "@/components/PolicyWrapper";

const TermOfService = () => {
  return (
    <PolicyWrapper title="Terms of Service">
      <div className="c15 doc-content">
        <p className="c16">
          <span className="c26">
            SET FORTH BELOW ARE THE TERMS AND CONDITIONS (THE
            &ldquo;AGREEMENT&rdquo;) FOR MOBILE TEXT MESSAGE AND EMAIL SERVICES
            OFFERED BY MENUSIFU, INC (THE &ldquo;SERVICES&rdquo;).{" "}
          </span>
        </p>
        <p className="c0">
          <span className="c9">
            BY EXECUTING AN ORDER FORM THAT REFERENCES THIS AGREEMENT, BY
            SIGNING UP FOR AN ACCOUNT, BY LOGGING IN TO YOUR ACCOUNT, BY
            ACCESSING ANY PART OF THE SERVICES (INCLUDING BY MEANS OF ANY API
            INTERFACE), YOU, AS A CUSTOMER OF THE SERVICES OR A REPRESENTATIVE
            OF AN ORGANIZATION THAT IS A CUSTOMER OF THE SERVICES (COLLECTIVELY,
            &ldquo;YOU&rdquo;), REPRESENT AND WARRANT (1) YOU HAVE READ,
            UNDERSTAND, AND AGREE TO BE BOUND BY THIS AGREEMENT, (2) YOU ARE AT
            LEAST EIGHTEEN (18) YEARS OF AGE, (3) THE INFORMATION YOU PROVIDED
            IN CONNECTION WITH YOUR REGISTRATION FOR THE SERVICES IS TRUE,
            ACCURATE, CURRENT AND COMPLETE, AND (4) YOU HAVE THE AUTHORITY TO
            ENTER INTO THIS AGREEMENT PERSONALLY OR ON BEHALF OF THE
            ORGANIZATION YOU HAVE NAMED AS THE AUTHORIZED USER, AND TO BIND THAT
            ORGANIZATION TO THIS AGREEMENT. NOTE THAT BY REPRESENTING AND
            WARRANTING THE ABOVE, YOU ARE MAKING A LEGALLY ENFORCEABLE
            AGREEMENT.{" "}
          </span>
        </p>
        <p className="c0">
          <span className="c3">
            Please note that we may change any terms of this Agreement which
            will be effective immediately upon posting or the effective date
            indicated in the new Agreement, as applicable, and apply to any
            continued or new use of the Services. We may change the Services, or
            any features of the Services at any time, and we may discontinue the
            Services or any features of the Services at any time. &nbsp;If you
            do not agree with the terms of this Agreement, you must immediately
            discontinue your use of the Services. Otherwise, your continued use
            of the Services constitutes your acceptance of such changes.
            &nbsp;We recommend that you regularly check our website to view the
            then-current terms.{" "}
          </span>
        </p>
        <p className="c0">
          <span className="c3">
            We may refuse service, close your accounts or the accounts of any
            Authorized Users, and change eligibility requirements at any time,
            in our sole discretion.
          </span>
        </p>
        <ol className="c5 lst-kix_list_5-0 start" start="1">
          <li className="c0 c12 li-bullet-0">
            <span className="c9">DEFINITIONS</span>
          </li>
        </ol>
        <p className="c0">
          <span className="c3">
            &ldquo;Equipment&rdquo; means any equipment and ancillary services
            needed to connect to, access or otherwise use the Services,
            including modems, hardware, servers, software, operating systems,
            networking, web servers.
          </span>
        </p>
        <p className="c0">
          <span className="c3">
            &ldquo;MenuSifu&rdquo;, &quot;we&quot;, &quot;us&quot; or
            &quot;our&quot; means MenuSifu, Inc. or its applicable subsidiaries
            or affiliates involved in the performance of this Agreement. &nbsp;
            &nbsp;
          </span>
        </p>
        <p className="c0">
          <span className="c3">
            &ldquo;Intellectual Property Rights&rdquo; means any and all
            intellectual property, industrial property, and other proprietary
            rights throughout the world, including all rights in, to, or arising
            out of patents, patent applications, inventions (whether patentable
            or not), invention disclosures, trade secrets, know-how, proprietary
            information, works of authorship, copyrights, mask works, moral
            rights, trademarks, service marks, software, data, technology,
            layout designs and design rights, and all registrations,
            applications, renewals, extensions, or reissues of any of the
            foregoing.{" "}
          </span>
        </p>
        <p className="c0">
          <span className="c3">
            &quot;Order Form&quot; means the form evidencing the initial order
            for Services, including any addendum or online confirmation form,
            and any subsequent orders separately entered into by you and us.
            Each Order Form shall be incorporated into and become a part of this
            Agreement.
          </span>
        </p>
        <p className="c0">
          <span className="c3">
            &quot;Services&quot; means, collectively, all our products and
            services and related offerings, features and functionalities,
            including digital marketing services via mobile text message and
            email and, and any related user interface designs, applications,
            including our mobile application, processes, software, source code,
            application programming interfaces, systems delivered or accessible
            through any media or device, images that are made available by us
            through any email or website builder tools, designs, templates,
            text, graphics, video, information, audio and other files, support,
            additional services and all related materials and documentation, and
            any and all enhancements and modifications thereto howsoever made,
            provided by or on behalf of us to you pursuant to this Agreement.
          </span>
        </p>
        <p className="c0">
          <span className="c3">
            &ldquo;Tax&rdquo; or &ldquo;Taxes&rdquo; means all applicable taxes,
            including indirect taxes such as goods and services tax
            (&ldquo;GST&rdquo;), value added tax (&ldquo;VAT&rdquo;), sales tax,
            fees, duties, levies, or other similar taxes.
          </span>
        </p>
        <ol className="c5 lst-kix_list_5-0" start="2">
          <li className="c4 li-bullet-0">
            <span className="c9">DESCRIPTION OF SERVICES.</span>
          </li>
        </ol>
        <p className="c11 c18">
          <span className="c9"></span>
        </p>
        <ol className="c5 lst-kix_list_6-0 start" start="1">
          <li className="c10">
            <span className="c3">
              The Services may include recurring and nonrecurring text messages
              and emails related to promotions, products, events, reminders,
              special offers or other information that we think will be of
              interest to you or you instructed us to deliver. Message and email
              frequency will vary. We reserve the right to alter the frequency
              of messages or emails sent at any time, so as to increase or
              decrease the total number of sent messages. Message and data rates
              may apply.
            </span>
          </li>
        </ol>
        <p className="c6 c23">
          <span className="c3">&nbsp;</span>
        </p>
        <ol className="c5 lst-kix_list_6-0" start="2">
          <li className="c10">
            <span className="c3">
              To access some features of the Service, you must register for an
              account (&ldquo;Account&rdquo;). When you register for an Account,
              you may be required to provide us with some information about
              yourself, such as your name, address, email address, billing
              information or other contact information. You agree that the
              information you provide to us is accurate and that you will keep
              it accurate and up-to-date at all times. You are solely
              responsible for maintaining the confidentiality of your Account,
              and you accept responsibility for all activities that occur under
              your Account. For purposes of this Agreement, you are the
              &ldquo;Account Owner&rdquo; and any other users you authorize will
              be deemed &ldquo;Authorized Users.&rdquo; To the extent
              applicable, Authorized Users that you appoint as your
              administrators shall have the authority to act on your behalf to
              perform administrative duties, enter into binding agreements and
              accept Fees (as defined below).
            </span>
          </li>
        </ol>
        <p className="c11 c6">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_6-0" start="3">
          <li className="c10">
            <span className="c3">
              You will not, and will not permit any Authorized User or other
              party to: (a) modify, adapt, alter, translate, or create
              derivative works of the Services; (b) sublicense, lease, rent,
              loan, distribute, or otherwise transfer the Services to any third
              party; (c) reverse engineer, decompile, disassemble, or otherwise
              derive or determine or attempt to derive or determine the source
              code (or the underlying ideas, algorithms, structure or
              organization) of the Services, except to the extent expressly
              permitted by applicable law (and then only upon advance written
              notice to us); (d) tamper, bypass, delete, or disable any copy
              protection or security mechanisms of the Services; (e) use or
              demonstrate the Services in any other way that is in competition
              with us; (f) remove any notice of proprietary rights from the
              Services; (g) attempt to gain unauthorized access to, or disrupt
              the integrity, performance or security of the Services or the data
              contained therein; (h) attempt to probe, scan or test the
              vulnerability of any Service or to breach the security or
              authentication measures without proper authorization; (i) use or
              copy the Services, except as expressly allowed herein or (j)
              otherwise use the Services in violation of this Agreement.{" "}
            </span>
          </li>
        </ol>
        <p className="c11 c6">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_5-0" start="3">
          <li className="c4 li-bullet-0">
            <span className="c9">LICENSES.</span>
          </li>
        </ol>
        <p className="c11 c18">
          <span className="c9"></span>
        </p>
        <ol className="c5 lst-kix_list_16-0 start" start="1">
          <li className="c10">
            <span className="c3">
              Subject to your complete and ongoing compliance with this
              Agreement, we grant you, solely for your own use, a limited,
              non-exclusive, non-transferable, non-sublicensable, revocable
              license to access and use the Service.
            </span>
          </li>
        </ol>
        <p className="c11 c6">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_16-0" start="2">
          <li className="c10">
            <span className="c3">
              If you choose to provide input and suggestions regarding problems
              with or proposed modifications or improvements to the Service
              (&ldquo;Feedback&rdquo;), then you hereby grant MenuSifu an
              unrestricted, perpetual, irrevocable, non-exclusive, fully-paid,
              royalty-free right to exploit the Feedback in any manner and for
              any purpose, including to improve the Services and create other
              products and services.
            </span>
          </li>
        </ol>
        <p className="c11 c6">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_5-0" start="4">
          <li className="c4 li-bullet-0">
            <span className="c9">USE OF THE SERVICES. </span>
          </li>
        </ol>
        <p className="c11 c18">
          <span className="c9"></span>
        </p>
        <ol className="c5 lst-kix_list_7-0 start" start="1">
          <li className="c0 c27 c28 li-bullet-1">
            <span className="c3">
              Except and solely to the extent such a restriction is
              impermissible under applicable law, You agree to comply with the
              following in connection with your use of the Services:
            </span>
          </li>
        </ol>
        <p className="c0">
          <span className="c3">
            &nbsp;(a) You may not reproduce, distribute, publicly display, or
            publicly perform the Services;{" "}
          </span>
        </p>
        <p className="c0">
          <span className="c3">
            (b) You may not make modifications to the Services;{" "}
          </span>
        </p>
        <p className="c0">
          <span className="c3">
            (c) You may not interfere with or circumvent any feature of the
            Services, including any security or access control mechanism. If you
            are prohibited under applicable law from using the Service, you may
            not use it.
          </span>
        </p>
        <p className="c0">
          <span className="c3">
            (b) You may not use our Services to promote or incite harm toward
            others or that promote discriminatory, hateful, or harassing
            content. We may suspend or terminate your account if you send or
            distribute content through the Services that we determine, in our
            sole discretion, contains either of the following:
          </span>
        </p>
        <p className="c0 c27">
          <span className="c3">
            (i) Any statement, photograph, advertisement, or other content that
            in our sole judgment could be reasonably perceived to threaten,
            advocate, or incite physical harm to or violence against others; or
          </span>
        </p>
        <p className="c0 c27">
          <span className="c3">
            (ii) Any statement, image, photograph, advertisement, or other
            content that in our sole judgment could be reasonably perceived to
            harm, threaten, promote the harassment of, promote the intimidation
            of, promote the abuse of, or promote discrimination against others
            based solely on race, ethnicity, national origin, sexual
            orientation, gender, gender identity, religious affiliation, age,
            disability, disease, or immigration status.
          </span>
        </p>
        <p className="c0">
          <span className="c3">
            (c) You may not use our Services if you are a person or you are a
            member of an organization that has publicly stated or acknowledged
            that its goals, objectives, positions, or founding tenets include
            statements or principles that could be reasonably perceived to
            advocate, encourage, or sponsor hateful content or a threat of
            physical harm.
          </span>
        </p>
        <p className="c0">
          <span className="c3">
            (d) You may not distribute content that is materially false,
            inaccurate, or misleading in a way that could deceive or confuse
            others about important events, topics, or circumstances.
          </span>
        </p>
        <p className="c0">
          <span className="c3">
            In the event that we determine, in our sole discretion, that you are
            not complying with this Section, we may terminate your access to or
            use of the Services, disable your account or access to the Services,
            and/or remove all or a portion of your content, in each case,
            without notice or liability and without refund.
          </span>
        </p>
        <ol className="c5 lst-kix_list_7-0" start="2">
          <li className="c8">
            <span className="c3">
              You are responsible for obtaining and maintaining the Equipment.
              You are also responsible for maintaining the security of the
              Equipment and for all uses of the Equipment with or without your
              knowledge or consent. You are responsible for making frequent
              backup copies of your contacts and content. We are not obligated
              to provide you with a way to download or otherwise export your
              contacts and content out of the Services.
            </span>
          </li>
        </ol>
        <p className="c13">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_7-0" start="3">
          <li className="c8">
            <span className="c3">
              &nbsp;For every listing, message or campaign sent or distributed
              via the Services, you agree that we may add a link to the Services
              and a statement such as &ldquo;Email Marketing by MenuSifu&rdquo;,
              &ldquo;Powered by MenuSifu&rdquo; or similar statements in the
              footer or other similar location that does not unreasonably
              obscure the Services.
            </span>
          </li>
        </ol>
        <p className="c2">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_7-0" start="4">
          <li className="c8">
            <span className="c3">
              You consent to us collecting data, including websites not
              provided, maintained, or hosted by us, through automated means,
              such as through harvesting bots, robots, spiders, or scrapers
              (&quot;Automated Data Collection&quot;) and the use of that data
              for internal business purposes.
            </span>
          </li>
        </ol>
        <p className="c13">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_7-0" start="5">
          <li className="c8">
            <span className="c3">
              You understand that not all content sent through the Services will
              be received by or will be capable of being viewed by their
              intended recipients or will be viewable by your recipients in the
              same way they appear in our Services environment. You further
              understand that delivery of content by means of the Services may
              involve transmissions over various networks, and that the content
              could be reformatted or otherwise revised to conform to the
              formatting or technical requirements of such networks. You also
              understand and agree that content exceeding maximum character
              limitations may be truncated, abbreviated, reduced or otherwise
              abruptly cut short.
            </span>
          </li>
        </ol>
        <p className="c13">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_7-0" start="6">
          <li className="c8">
            <span className="c3">
              The Services may permit your customers and users to, among other
              things, (a) create deal for selling your products and/or services,
              (b) book appointments with your customers and users, or (c)
              collect information from your customers and users (collectively,
              &ldquo;Your Products&rdquo;).
            </span>
          </li>
        </ol>
        <p className="c2">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_7-0" start="7">
          <li className="c8">
            <span className="c3">
              You are solely responsible for Your Products, including any and
              all injuries, illnesses, damages, claims, liabilities and costs
              suffered in respect thereto. You shall be responsible for all
              costs of procuring and delivering Your Products, including any
              associated shipping, taxes and any other fees associated
              therewith.{" "}
            </span>
          </li>
        </ol>
        <p className="c2">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_7-0" start="8">
          <li className="c8">
            <span className="c3">
              You will be solely responsible for any and all statements and
              promises you make and for all user assistance, warranty and
              support of Your Products, and to comply with any promises you make
              to your customers and user. You further agree to provide your
              contact information for any end-user questions, complaints or
              claims.{" "}
            </span>
          </li>
        </ol>
        <p className="c13">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_5-0" start="5">
          <li className="c4 li-bullet-0">
            <span className="c9">THIRD PARTY TERMS</span>
          </li>
        </ol>
        <p className="c11 c18">
          <span className="c9"></span>
        </p>
        <ol className="c5 lst-kix_list_18-0 start" start="1">
          <li className="c8">
            <span className="c3">
              The Services may incorporate products or services provided or
              operated by third parties, which may include marketing and
              advertising services, social network platforms, publication and
              delivery services, payment processing services and other payment
              intermediaries or websites (each, a &ldquo;Third Party
              Service&rdquo;), some of which may have established relationships
              with us and some of which may not. By using one of these tools,
              you agree that Company may transfer that information to the
              applicable Third Party Service. We do not have control over the
              content and performance of Third Party Services. We have not
              reviewed, and cannot review or control, the material, including
              computer software or other goods or services, made available on
              Third Party Services, and we do not represent, warrant, or endorse
              any Third Party Services, or the accuracy, currency, content,
              fitness, lawfulness, or quality of the information, material,
              goods, or services available through Third Party Services. We
              disclaim, and you agree to assume, all responsibility and
              liability for any damages or other harm, whether to you or to
              third parties, resulting from your use of Third Party Services.
              &nbsp;We may terminate any Third Party Services&#39; ability to
              interact with the Services at any time, with or without notice,
              and in our sole discretion, with no liability to you or to any
              third party.
            </span>
          </li>
        </ol>
        <p className="c2">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_18-0" start="2">
          <li className="c8">
            <span className="c3">
              You agree to abide by the terms and conditions of any applicable
              Third Party Service (such as Google, Twilio and Apple).
              Notwithstanding anything set forth herein to the contrary, you
              will abide by this Agreement regardless of anything to the
              contrary in your agreement with any third party and you shall not
              use such Third Party Service to avoid the restrictions set forth
              in this Agreement.
            </span>
          </li>
        </ol>
        <p className="c11 c18">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_5-0" start="6">
          <li className="c4 li-bullet-0">
            <span className="c9">INTELLECTUAL PROPERTY.</span>
          </li>
        </ol>
        <p className="c11 c18">
          <span className="c9"></span>
        </p>
        <ol className="c5 lst-kix_list_8-0 start" start="1">
          <li className="c17">
            <span className="c3">
              We own and shall retain all right, title and interest in and to
              all Intellectual Property Rights in the Services. &nbsp;Except as
              expressly set forth herein, no express or implied license or right
              of any kind is granted to you regarding the Services, including
              any right to obtain possession of any software, source code, data
              or technical material related to the Services. &nbsp;Any use of
              the Services other than as specifically authorized herein is
              prohibited and will automatically terminate your rights with
              respect to your use of the Services.{" "}
            </span>
          </li>
        </ol>
        <p className="c11 c6">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_8-0" start="2">
          <li className="c17">
            <span className="c3">
              You own any information that you provide to us in connection with
              your use of the Services, such as contact lists (including email
              addresses and phone numbers of your contacts) and other content
              (including your website) (collectively, &ldquo;Customer
              Data&rdquo;). You grant us a limited, non-exclusive, royalty-free,
              worldwide license, with the right to sublicense, use, reproduce,
              publish, distribute, perform and display your Customer Data in
              order (a) to provide the Services under this Agreement, (b) to
              develop services, and (c) to comply with any court order, legal
              process, law, regulation or any request from a governmental,
              regulatory or supervisory body. &nbsp;We may use and disclose
              aggregated data that does not identify Customer or any natural
              person for our legitimate business purposes, including
              improvements to the Services, product development, research and
              marketing.{" "}
            </span>
          </li>
        </ol>
        <p className="c13">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_8-0" start="3">
          <li className="c17">
            <span className="c3">
              You are solely responsible for obtaining valid consent from your
              customers and users as needed for provision of your products or
              service that may incorporate, reference or utilize the Services.
              You are solely responsible for the accuracy, quality, integrity,
              legality, reliability and appropriateness of Customer Data, and
              you are responsible for maintaining, securing and storing your
              contacts and content in accordance with applicable law and any
              contractual obligations you may have (including this Agreement).{" "}
            </span>
          </li>
        </ol>
        <p className="c11 c6">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_8-0" start="4">
          <li className="c17">
            <span className="c3">
              If you submit any suggestions, business information, ideas,
              concepts or inventions or content to us through the Services or
              otherwise (&ldquo;Submissions&rdquo;), you agree that each such
              Submission is non-confidential for all purposes and you
              automatically grant, or warrant that the owner of such content or
              intellectual property has expressly granted, us a non-exclusive,
              royalty-free, perpetual, irrevocable, worldwide license, with the
              right to sublicense, to use, reproduce, create derivative works
              from, modify, publish, edit, translate, distribute, perform and
              display such Submission in any manner or in any media now known or
              hereafter created.
            </span>
          </li>
        </ol>
        <p className="c11 c18">
          <span className="c9"></span>
        </p>
        <ol className="c5 lst-kix_list_5-0" start="7">
          <li className="c4 li-bullet-0">
            <span className="c9">FEES; PAYMENT; TAXES.</span>
          </li>
        </ol>
        <p className="c11 c18">
          <span className="c9"></span>
        </p>
        <ol className="c5 lst-kix_list_9-0 start" start="1">
          <li className="c7">
            <span className="c3">
              In consideration for the Services, you agree to pay us the fee set
              forth in an applicable Order Form (&ldquo;Fees&rdquo;). We may
              change any of our Fees at any time by posting a new pricing
              schedule to the Services or in your account and/or sending you a
              notification by email. You are responsible for reviewing the Fees
              from time to time and remaining aware of the Fees charged by us
              and any applicable discounts. You acknowledge and agree that our
              measurements are the definitive measurements for any payment due
              and owed hereunder.
            </span>
          </li>
        </ol>
        <p className="c11 c21">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_9-0" start="2">
          <li className="c7">
            <span className="c3">
              Notwithstanding anything set forth herein to the contrary, any
              disputes about any charges to you under this Agreement or
              applicable Order Form must be submitted to us in writing within
              sixty (60) days of the date such charges are incurred. You agree
              to waive all disputes not brought within the sixty (60) day
              period, and all such charges will be final and not subject to
              challenge.
            </span>
          </li>
        </ol>
        <p className="c13">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_9-0" start="3">
          <li className="c7">
            <span className="c3">
              &nbsp;Unless otherwise stated, any Fees or any other amounts are
              exclusive of Taxes. In the event that any amount payable by you to
              us is subject to Taxes, we will collect the full amount of those
              Taxes from you and the collection shall not reduce or somehow
              impact on the amount to which we are entitled. You must pay any
              applicable Taxes. In the event that any payments and/or amount
              payable by you to us is subject to (a) any withholding or similar
              tax, (b) any Taxes not collected by us, or (c) any other Taxes or
              other government levy of whatever nature, the full amount of that
              Tax or levy shall be solely your responsibility and shall not
              reduce the amount to which we are entitled under this Agreement.
              You will reimburse us and indemnify and hold us harmless against
              any and all claims by any competent tax authority related to any
              Taxes, including withholding or similar Taxes, penalties and/or
              interest &nbsp;that we may be compelled to pay on account of your
              non-payment.
            </span>
          </li>
        </ol>
        <p className="c13">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_5-0" start="8">
          <li className="c0 c12 li-bullet-0">
            <span className="c9">COMPLIANCE WITH LAWS. </span>
          </li>
        </ol>
        <p className="c0 c24">
          <span className="c19">
            You represent and warrant that your use of the Services, including
            in connection with Your Products, will comply with all applicable
            laws and regulations. You are responsible for determining whether
            the Services are suitable for you to use in light of your
            obligations under any applicable laws or regulations. You may not
            use the Services for any unlawful or discriminatory activities,
            including acts prohibited by the Federal Trade Commission Act, Fair
            Credit Reporting Act, Equal Credit Opportunity Act, or other laws
            that apply to commerce.
          </span>
        </p>
        <p className="c11 c14">
          <span className="c9"></span>
        </p>
        <ol className="c5 lst-kix_list_5-0" start="9">
          <li className="c4 li-bullet-0">
            <span className="c9">PRIVACY.</span>
          </li>
        </ol>
        <p className="c13">
          <span className="c9"></span>
        </p>
        <ol className="c5 lst-kix_list_11-0 start" start="1">
          <li className="c7">
            <span className="c3">
              Each party shall comply with all laws and regulations of the
              relevant jurisdictions that apply to its respective performance of
              obligations and exercise of rights under this Agreement, including
              the Regulation (EU) 2016/679 of 27 April 2016, General Data
              Protection Regulation (the &ldquo;GDPR&rdquo;), the California
              Consumer Privacy Act (the &ldquo;CCPA&rdquo;), as amended by the
              California Privacy Rights Act (the &ldquo;CPRA&rdquo;), and other
              U.S. federal or state data privacy and data protection laws, and
              related implementing regulations (collectively, &ldquo;Data
              Privacy Laws&rdquo;).
            </span>
          </li>
        </ol>
        <p className="c11 c21">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_11-0" start="2">
          <li className="c7">
            <span className="c3">
              You warrant that (a) you have complied, and shall continue to
              comply, with Data Privacy Laws in your collection, processing and
              provision to us of personal information; and (b) you shall not
              process any personal information using the Services, or permit us
              to process any personal information, in breach or contravention of
              any order issued to, or limitation of processing imposed on, you
              by any regulatory authority.
            </span>
          </li>
        </ol>
        <p className="c13">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_11-0" start="3">
          <li className="c7">
            <span className="c3">
              You agree to and comply with our privacy policy which can be found
              here{" "}
            </span>
            <span className="c19">(</span>
            <span className="c19 c29">
              <a
                className="c20"
                href="https://www.google.com/url?q=https://www.menusifu.com/legal/Privacy-Policy&amp;sa=D&amp;source=editors&amp;ust=1689750261588488&amp;usg=AOvVaw3T1myF2LnInAyKqsc3Fxex"
              >
                https://www.menusifu.com/legal/Privacy-Policy
              </a>
            </span>
            <span className="c19">)</span>
            <span className="c3">&nbsp;</span>
          </li>
          <li className="c7">
            <span className="c3">
              &nbsp;and is incorporated into this Agreement. You warrant you
              have adopted and complied with a legally sufficient
              &ldquo;customer privacy notice.&rdquo; Your privacy notice will be
              posted so that your contacts have notice of your data collection
              and use practices, including your practices with respect to
              contact data that you obtain from us, and will otherwise comply
              with Data Privacy Laws.{" "}
            </span>
          </li>
        </ol>
        <p className="c13">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_11-0" start="5">
          <li className="c7">
            <span className="c3">
              You shall monitor and process &ldquo;unsubscribe&rdquo; or
              &ldquo;opt-out&rdquo; requests received by you directly within ten
              (10) days of submission and update the contacts to which messages
              are sent through your &nbsp;account. You cannot charge a fee,
              require the recipient to give you any personally identifying
              information beyond a necessary contact information, or make the
              recipient take any unnecessary step as a condition for honoring an
              unsubscribe or opt-out &nbsp;request. As required under the
              CAN-SPAM Act and other applicable laws, you acknowledge that you
              are responsible for maintaining and honoring the list of
              unsubscribe or opt-out requests during the Term of this Agreement.
            </span>
          </li>
        </ol>
        <p className="c13">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_5-0" start="10">
          <li className="c4 li-bullet-0">
            <span className="c9">TERM AND TERMINATION.</span>
          </li>
        </ol>
        <p className="c11 c14">
          <span className="c9"></span>
        </p>
        <ol className="c5 lst-kix_list_12-0 start" start="1">
          <li className="c10">
            <span className="c3">
              The term of this Agreement shall be monthly, or to the extent
              applicable, the period specified in your Order Form (the
              &ldquo;Initial Term&rdquo;). &nbsp;The Initial Term shall
              automatically renew for additional monthly periods or as specified
              in your Order Form (each a &ldquo;Renewal Term&rdquo;, and
              together with the Initial Term, the &ldquo;Term&rdquo;).
            </span>
          </li>
        </ol>
        <p className="c11 c6">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_12-0" start="2">
          <li className="c10">
            <span className="c3">
              To terminate your account or subscription for any of the Services,
              you must request termination at least thirty (30) days prior to
              the end of the current Term. Except as otherwise agreed to by us
              in writing, there are no refunds for any pre-paid Fees. We may
              terminate this Agreement at any time without cause. WE ARE NOT
              RESPONSIBLE FOR YOUR FAILURE TO PROPERLY TERMINATE YOUR ACCOUNT
              AND/OR SUBSCRIPTION TO THE SERVICES OR FOR ANY CREDIT CARD OR
              OTHER CHARGES OR FEES YOU INCUR AS A RESULT OF YOUR FAILURE TO
              PROPERLY TERMINATE YOUR ACCOUNT AND/OR SUBSCRIPTION. &nbsp;
            </span>
          </li>
        </ol>
        <p className="c13">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_12-0" start="3">
          <li className="c10">
            <span className="c3">
              Upon termination or expiration of your account and/or subscription
              for the Services, this Agreement and any rights or licenses
              granted to you hereunder shall immediately terminate, except that
              (a) all sections of this Agreement that by their nature should
              survive termination will survive termination, and (b) you will
              continue to be responsible for your Products. &nbsp;Under the
              CAN-SPAM Act, Canada&rsquo;s Anti-Spam Legislation and the GDPR,
              as applicable, you acknowledge that you are responsible for
              maintaining and honoring the list of unsubscribe or opt-out
              requests following termination of your account and/or
              subscription. If your account is classified (in our sole
              discretion) as inactive for over 120 days, we have the right to
              permanently delete any of your contacts and content.
            </span>
          </li>
        </ol>
        <p className="c13">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_5-0" start="11">
          <li className="c0 c12 li-bullet-0">
            <span className="c9">INDEMNIFICATION. </span>
          </li>
        </ol>
        <p className="c0">
          <span className="c19">
            You hereby agree to defend, indemnify and hold us, our officers,
            directors, employees, affiliates, subsidiaries, licensors, agents,
            members, sponsors, investors, agents, and representatives (each, an
            &ldquo;Indemnified Party&rdquo;) harmless from any losses, damages,
            judgments, fines, reasonable attorneys&rsquo; fees, and costs, in
            connection with any third party claims arising out of or relating to
            (a) any actual or alleged breach by you of this Agreement, (b) your
            contacts and content, including the content or effects of any
            messages you distribute, or Your Products (including claims relating
            to violations of law, false advertising, injuries, illness, damages,
            death, taxes, fulfillment, defective products or services or
            unclaimed property), or (c) otherwise arises from or relates to your
            use of the Services. &nbsp;Any settlement that does not fully
            release the Indemnified Party from liability or which would impose
            any monetary, injunctive or other obligation or restriction upon the
            Indemnified Party shall be subject to the Indemnified Party&#39;s
            prior written approval. The Indemnified Party may participate in the
            defense of the claim with counsel of its choosing at its expense;
            provided, that if you fail to promptly assume the defense or
            settlement of the claim, the Indemnified Party may assume sole
            control of the defense of the claim at your expense.
          </span>
        </p>
        <ol className="c5 lst-kix_list_5-0" start="12">
          <li className="c4 li-bullet-0">
            <span className="c9">REPRESENTATION AND WARRANTIES.</span>
          </li>
        </ol>
        <p className="c11 c14">
          <span className="c9"></span>
        </p>
        <ol className="c5 lst-kix_list_13-0 start" start="1">
          <li className="c22">
            <span className="c3">
              You represent and warrant that (a) you have all necessary rights
              and consents to post and distribute Your Products and the Customer
              Data through the Services, (b) that Your Products and Customer
              Data will (i) not infringe, misappropriate, or otherwise violate
              the Intellectual Property Rights or other rights of any third
              party, (ii) not constitute defamation, invasion of privacy or
              publicity, or otherwise violate any similar rights of any third
              party, (iii) not be used in any activity in violation of the law
              or to promote such activities, including a manner that might be
              illegal or harmful to any person or entity, and (iv) comply with
              applicable industry standards, and (c) that your use of the
              Services will not violate any rules, restrictions, policies, or
              requirements of your email service provider, internet service
              provider or other applicable service provider.
            </span>
          </li>
        </ol>
        <p className="c11 c18">
          <span className="c9"></span>
        </p>
        <ol className="c5 lst-kix_list_5-0" start="13">
          <li className="c0 c12 li-bullet-0">
            <span className="c9">WARRANTY DISCLAIMER; REMEDIES; RELEASE.</span>
          </li>
        </ol>
        <p className="c0">
          <span className="c3">
            YOU EXPRESSLY AGREE THAT THE SERVICES ARE PROVIDED ON AN &ldquo;AS
            IS&rdquo; AND &ldquo;AS AVAILABLE&rdquo; BASIS. USE OF THE SERVICES,
            INCLUDING IN CONNECTION WITH YOUR PRODUCTS, AND ANY RELIANCE BY YOU
            UPON THE SERVICES, INCLUDING ANY ACTION TAKEN BY YOU BECAUSE OF SUCH
            USE OR RELIANCE, IS AT YOUR SOLE RISK. WE DO NOT WARRANT THAT THE
            USE OF THE SERVICES WILL BE UNINTERRUPTED OR ERROR FREE OR
            COMPLETELY SECURE, NOR DO WE MAKE ANY WARRANTY AS TO THE RESULTS
            THAT MAY BE OBTAINED FROM USE OF THE SAME. WE DISCLAIM ALL
            WARRANTIES, EXPRESS OR IMPLIED, INCLUDING IMPLIED WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. NO STATEMENT OR INFORMATION, WHETHER ORAL OR
            WRITTEN, OBTAINED FROM US IN ANY MEANS OR FASHION SHALL CREATE ANY
            WARRANTY NOT EXPRESSLY AND EXPLICITLY SET FORTH IN THIS AGREEMENT.
          </span>
        </p>
        <p className="c0">
          <span className="c3">
            NO CLAIM MAY BE ASSERTED BY YOU AGAINST US MORE THAN 12 MONTHS AFTER
            THE DATE OF THE CAUSE OF ACTION UNDERLYING SUCH CLAIM. YOUR SOLE AND
            EXCLUSIVE REMEDY FOR ANY FAILURE OR NONPERFORMANCE OF THE SERVICES
            SHALL BE FOR US TO USE COMMERCIALLY REASONABLE EFFORTS TO ADJUST OR
            REPAIR THE SERVICES.
          </span>
        </p>
        <p className="c0">
          <span className="c3">
            TO THE EXTENT APPLICABLE LAW PERMITS, YOU RELEASE US FROM ANY CLAIMS
            OR LIABILITY RELATED TO (A) YOUR PRODUCTS, (B) ANY CONTENT POSTED ON
            OUR SERVICES OR IN ANY MATERIALS YOU SEND USING THE SERVICES, AND
            (C) ANY PROBLEMS THAT MAY ARISE FROM ANY REMOTE ACCESS TO YOUR
            COMPUTERS OR OTHER SYSTEMS YOU PROVIDE TO OUR PERSONNEL OR AGENTS
            FOR THE PURPOSE OF TROUBLESHOOTING ISSUES. YOU HEREBY WAIVE
            CALIFORNIA CIVIL CODE SECTION 1542 (IF YOU ARE A CALIFORNIA
            RESIDENT), AND ANY SIMILAR PROVISION IN ANY OTHER JURISDICTION (IF
            YOU ARE A RESIDENT OF SUCH JURISDICTION).
          </span>
        </p>
        <ol className="c5 lst-kix_list_5-0" start="14">
          <li className="c0 c12 li-bullet-0">
            <span className="c9">LIMITATION OF LIABILITY.</span>
          </li>
        </ol>
        <p className="c0">
          <span className="c3">
            EXCEPT WITH RESPECT TO DEATH OR PERSONAL INJURY DUE TO OUR GROSS
            NEGLIGENCE, TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, UNDER
            NO CIRCUMSTANCES AND UNDER NO LEGAL THEORY, TORT, CONTRACT, OR
            OTHERWISE, SHALL MENUSIFU OR ANY OF ITS UNDERLYING SERVICE
            PROVIDERS, BUSINESS PARTNERS, ACCOUNT PROVIDERS, LICENSORS,
            AFFILIATES, OFFICERS, DIRECTORS, EMPLOYEES, DISTRIBUTORS OR AGENTS
            (COLLECTIVELY REFERRED TO FOR PURPOSES OF THIS SECTION AS
            &ldquo;MENUSIFU&rdquo;) BE LIABLE TO YOU OR ANY OTHER PERSON FOR ANY
            MONEY DAMAGES, WHETHER DIRECT, INDIRECT, SPECIAL, INCIDENTAL, COVER,
            RELIANCE OR CONSEQUENTIAL DAMAGES, EVEN IF MENUSIFU SHALL HAVE BEEN
            INFORMED OF THE POSSIBILITY OF SUCH DAMAGES, OR FOR ANY CLAIM BY ANY
            OTHER PARTY, AND REGARDLESS OF THE FORM OF ACTION (WHETHER IN
            CONTRACT, TORT (INCLUDING NEGLIGENCE), PRODUCT LIABILITY OR
            OTHERWISE), THE MAXIMUM AGGREGATE LIABILITY TO YOU ARISING IN
            CONNECTION WITH THIS AGREEMENT SHALL BE LIMITED TO THE AMOUNT YOU
            PAID FOR THE APPLICABLE SERVICES IN THE TWELVE (12) MONTHS PRIOR TO
            THE ACCRUAL OF THE APPLICABLE CLAIM, LESS ANY DAMAGES PREVIOUSLY
            PAID BY US TO YOU IN THAT TWELVE (12) MONTH PERIOD. SOME
            JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF INCIDENTAL
            OR CONSEQUENTIAL DAMAGES, SO THIS LIMITATION AND EXCLUSION MAY NOT
            APPLY TO YOU.
          </span>
        </p>
        <p className="c0">
          <span className="c3">
            YOU AGREE THAT WE HAVE SET OUR FEES AND ENTERED INTO THIS AGREEMENT
            IN RELIANCE UPON THE DISCLAIMERS OF WARRANTY AND THE LIMITATIONS OF
            LIABILITY SET FORTH HEREIN, THAT THEY REFLECT AN ALLOCATION OF RISK
            BETWEEN THE PARTIES (INCLUDING THE RISK THAT A CONTRACT REMEDY MAY
            FAIL OF ITS ESSENTIAL PURPOSE AND CAUSE CONSEQUENTIAL LOSS), AND
            THAT THEY FORM AN ESSENTIAL BASIS OF THE BARGAIN BETWEEN THE
            PARTIES.
          </span>
        </p>
        <ol className="c5 lst-kix_list_5-0" start="15">
          <li className="c4 li-bullet-0">
            <span className="c9">MISCELLANEOUS.</span>
          </li>
        </ol>
        <p className="c11 c6">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_15-0 start" start="1">
          <li className="c10">
            <span className="c3">
              &nbsp;If any provision of this Agreement is found to be
              unenforceable or invalid, that provision will be limited or
              eliminated to the minimum extent necessary so that this Agreement
              will otherwise remain in full force and effect and enforceable.
            </span>
          </li>
        </ol>
        <p className="c11 c6">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_15-0" start="2">
          <li className="c10">
            <span className="c3">
              Each party agrees that this Agreement, together with any Order
              Form entered into by the parties, is the complete and exclusive
              statement of the mutual understanding of the parties and
              supersedes and cancels all previous written and oral agreements,
              communications and other understandings relating to the subject
              matter of this Agreement and any Order Form entered into by the
              parties pertaining to such subject matter, and that all waivers
              and modifications must be in writing signed by both parties,
              except as otherwise provided herein. However, in the event of a
              conflict between the provisions of this Agreement and any Order
              Form entered into by the parties, the terms of such Order Form
              shall prevail. No delay or omission by either party in exercising
              any right or remedy under this Agreement, an Order Form, or
              existing at law or equity shall be considered a waiver of such
              right or remedy.
            </span>
          </li>
        </ol>
        <p className="c13">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_15-0" start="3">
          <li className="c10">
            <span className="c3">
              Assignment. You may not assign any of your rights hereunder. We
              may assign all rights to any other individual or entity in our
              sole discretion.
            </span>
          </li>
        </ol>
        <p className="c13">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_15-0" start="4">
          <li className="c10">
            <span className="c3">
              You agree to execute any and all documents and take any other
              actions reasonably required or necessary to effectuate the
              purposes of this Agreement.
            </span>
          </li>
        </ol>
        <p className="c11 c6">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_15-0" start="5">
          <li className="c10">
            <span className="c3">
              We are not liable for any failure, default or delay in the
              performance of any part of the Services or of our obligations
              under this Agreement if such default or delay is caused, directly
              or indirectly, by forces beyond our reasonable control, including
              fire, flood, acts of God, changes to law or regulations,
              embargoes, labor disputes, accidents, insurrection, epidemic,
              pandemic, acts of war (declared or undeclared) or terrorism,
              riots, interruptions of transportation or communications, supply
              shortages or the failure of any third party to perform any
              commitment relative to the production or delivery of any equipment
              or material required for us to perform our obligations hereunder,
              including acts of hackers or third-party internet service
              providers.
            </span>
          </li>
        </ol>
        <p className="c11 c6">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_15-0" start="6">
          <li className="c10">
            <span className="c3">
              Our affiliates, underlying service providers, business partners,
              third-party suppliers and providers, account providers, licensors,
              officers, directors, employees, distributors and agents are
              expressly made third party beneficiaries of this Agreement. Except
              as set forth in the immediately preceding sentence, nothing
              express or implied in this Agreement is intended to confer, nor
              shall anything herein confer, upon any person other than the
              parties and the respective permitted successors or assigns of the
              parties, any rights, remedies, obligations or liabilities
              whatsoever.
            </span>
          </li>
        </ol>
        <p className="c6 c11">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_15-0" start="7">
          <li className="c10">
            <span className="c3">
              Nothing contained in this Agreement shall be construed as creating
              any agency, partnership, joint venture, or other form of joint
              enterprise, employment, or fiduciary relationship between the
              parties. Neither party, by virtue of this Agreement, will have any
              right, power, nor authority to act or create an obligation,
              express or implied, on behalf of the other party.
            </span>
          </li>
        </ol>
        <p className="c11 c6">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_15-0" start="8">
          <li className="c10">
            <span className="c3">
              In any action or proceeding to enforce rights under this
              Agreement, the prevailing party will be entitled to recover its
              costs and attorneys&rsquo; fees.
            </span>
          </li>
        </ol>
        <p className="c11 c6">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_15-0" start="9">
          <li className="c10">
            <span className="c3">
              You hereby submit to the exclusive jurisdiction of the American
              Arbitration Association (&ldquo;AAA&rdquo;) in connection with any
              dispute relating to, concerning or arising out of this Agreement,
              whether in contract, tort, fraud, misrepresentation or any other
              legal theory. The arbitration will be conducted before a single
              arbitrator and will be held at the AAA location in Boston,
              Massachusetts, unless you are a &ldquo;consumer&rdquo; as defined
              under the AAA rules. Disputes with consumers, as therein defined,
              will be resolved by binding arbitration conducted under the
              AAA&rsquo;s Consumer Arbitration Rules, as applicable. Consumers
              may request that the arbitration occur in or near the city/state
              stated in your account record with us. The procedures for
              commencing an arbitration are available here (provided however,
              that you may assert claims in small claims court, if your claims
              qualify and so long as the matter remains in such court only on an
              individual, non-class basis).
            </span>
          </li>
        </ol>
        <p className="c0 c6 c25">
          <span className="c3"></span>
        </p>
        <p className="c0">
          <span className="c3">
            ARBITRATION MUST BE ON AN INDIVIDUAL BASIS. THIS MEANS NEITHER YOU
            NOR WE MAY JOIN OR CONSOLIDATE CLAIMS IN ARBITRATION BY OR AGAINST
            OTHER CUSTOMERS, SUBSCRIBERS OR USERS, OR LITIGATE IN COURT OR
            ARBITRATE ANY CLAIMS AS A REPRESENTATIVE OR MEMBER OF A CLASS OR IN
            A PRIVATE ATTORNEY GENERAL CAPACITY. Only a court, and not an
            arbitrator, shall determine the validity and effect of the class
            action waiver. Even if all parties have opted to litigate a claim in
            court, you or we may elect arbitration with respect to any claim
            made by a new party or any new claims later asserted in that
            lawsuit. Payment of all filing, administration and arbitrator fees
            will be governed by the AAA&rsquo;s rules, unless otherwise stated
            in this Section. In the event you are able to demonstrate that the
            costs of arbitration will be prohibitive as compared to the costs of
            litigation, we will pay as much of your filing, administrative, and
            arbitrator fees in connection with the arbitration as the arbitrator
            deems necessary to prevent the arbitration from being
            cost-prohibitive. No arbitration award or decision will have any
            preclusive effect as to issues or claims in any dispute with anyone
            who is not a named party to the arbitration. If you initiate a
            litigation or any other proceeding against us in violation of this
            paragraph, you agree to pay our reasonable costs and
            attorneys&rsquo; fees incurred in connection with its enforcement of
            this paragraph. The parties shall maintain the confidential nature
            of the arbitration proceeding and any award, including the hearing,
            except as may be necessary to prepare for or conduct the arbitration
            hearing on the merits, or except as may be necessary in connection
            with a court application for a preliminary remedy, a judicial
            challenge to an award or its enforcement, or unless otherwise
            required by law or judicial decision. This Agreement and the rights
            of the parties hereunder shall be governed by and construed in
            accordance with the laws of the Commonwealth of Massachusetts,
            exclusive of conflict or choice of law rules. The parties
            acknowledge that this Agreement evidences a transaction involving
            interstate commerce. Notwithstanding the provision in the preceding
            paragraph with respect to applicable substantive law, any
            arbitration conducted pursuant to the terms of this Agreement shall
            be governed by the Federal Arbitration Act (9 U.S.C., Secs. 1-16).
          </span>
        </p>
        <p className="c11 c6">
          <span className="c3"></span>
        </p>
        <ol className="c5 lst-kix_list_15-0" start="10">
          <li className="c10">
            <span className="c3">
              Your violation of this Agreement may cause irreparable harm to us.
              Therefore, we have the right to seek injunctive relief or other
              equitable relief if you violate this Agreement.
            </span>
          </li>
        </ol>
        <p className="c11 c6">
          <span className="c3"></span>
        </p>
        <p className="c11 c6">
          <span className="c3"></span>
        </p>
        <p className="c0 c6">
          <span className="c3">Updated on </span>
          <span className="c19">May 8th</span>
          <span className="c3">, 2023.</span>
        </p>
      </div>
    </PolicyWrapper>
  );
};

export default TermOfService;
